module.exports = __webpack_public_path__ + "img/thumb_Atelier_1.d27d55f9.jpg";